/* PROMSA · despacho por comuna + selector de cama (ficha de camas y listicle)
   Datos verificados el 26-sep-2026 cotizando la Cama Eléctrica 3 pos + antiescaras
   en /cart/shipping_rates.json. Si cambian las tarifas o las comunas con reparto propio,
   se actualiza solo este archivo. */
(function () {
  'use strict';

  var WSP = 'https://wa.me/56933935089';

  // Comunas de la RM donde el checkout ofrece "Despacho a domicilio" a $0 (44 de 52).
  var RM_GRATIS = ['Buin', 'Calera de Tango', 'Cerrillos', 'Cerro Navia', 'Colina', 'Conchalí',
    'El Bosque', 'Estación Central', 'Huechuraba', 'Independencia', 'Isla de Maipo', 'La Cisterna',
    'La Florida', 'La Granja', 'La Pintana', 'La Reina', 'Lampa', 'Las Condes', 'Lo Barnechea',
    'Lo Espejo', 'Lo Prado', 'Macul', 'Maipú', 'Ñuñoa', 'Padre Hurtado', 'Paine',
    'Pedro Aguirre Cerda', 'Peñaflor', 'Peñalolén', 'Pirque', 'Providencia', 'Pudahuel',
    'Puente Alto', 'Quilicura', 'Quinta Normal', 'Recoleta', 'Renca', 'San Bernardo', 'San Joaquín',
    'San Miguel', 'San Ramón', 'Santiago', 'Talagante', 'Vitacura'];

  // Comunas de la RM que solo tienen Starken (valor para la cama de referencia).
  var RM_STARKEN = { 'Alhué': 185890, 'Curacaví': 124002, 'El Monte': 124002, 'María Pinto': 124002,
    'Melipilla': 124002, 'San José de Maipo': 124002, 'San Pedro': 0, 'Tiltil': 124002 };

  // Starken a la capital de cada región (valor para la cama de referencia).
  var REGIONES = [
    ['Arica y Parinacota', 'Arica', 140917], ['Tarapacá', 'Iquique', 132786],
    ['Antofagasta', 'Antofagasta', 115689], ['Atacama', 'Copiapó', 90292],
    ['Coquimbo', 'La Serena', 74336], ['Valparaíso', 'Valparaíso', 74094],
    ["O'Higgins", 'Rancagua', 74094], ['Maule', 'Talca', 74653], ['Ñuble', 'Chillán', 76813],
    ['Biobío', 'Concepción', 79928], ['La Araucanía', 'Temuco', 86067], ['Los Ríos', 'Valdivia', 97086],
    ['Los Lagos', 'Puerto Montt', 100766], ['Aysén', 'Coyhaique', 272520],
    ['Magallanes', 'Punta Arenas', 287368]];

  function plata(n) { return '$' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function opt(v, t) { var o = document.createElement('option'); o.value = v; o.textContent = t; return o; }

  function iniciarDespacho(caja) {
    if (caja.getAttribute('data-listo')) return;
    caja.setAttribute('data-listo', '1');
    var conRef = caja.getAttribute('data-ref') === 'true';
    var armado = caja.getAttribute('data-armado') || '';
    var selR = caja.querySelector('[data-asq-region]');
    var selC = caja.querySelector('[data-asq-comuna]');
    var res = caja.querySelector('[data-asq-res]');
    if (!selR || !selC || !res) return;

    selR.appendChild(opt('', 'Elige tu región'));
    selR.appendChild(opt('RM', 'Región Metropolitana'));
    REGIONES.forEach(function (r, i) { selR.appendChild(opt('R' + i, r[0])); });

    var todas = RM_GRATIS.concat(Object.keys(RM_STARKEN)).sort(function (a, b) { return a.localeCompare(b, 'es'); });
    selC.appendChild(opt('', 'Elige tu comuna'));
    todas.forEach(function (c) { selC.appendChild(opt(c, c)); });

    var videoArmado = armado
      ? ' <a href="' + armado + '" target="_blank" rel="noopener">Mira el video del armado</a>.'
      : '';
    var rural = '<p>Si la dirección es rural, Starken la deja en su sucursal más cercana.</p>';

    function pintar() {
      var r = selR.value;
      selC.hidden = r !== 'RM';
      if (!r) { res.innerHTML = ''; return; }
      if (r === 'RM') {
        var c = selC.value;
        if (!c) { res.innerHTML = ''; return; }
        if (RM_GRATIS.indexOf(c) > -1) {
          res.innerHTML = '<div class="asq-res asq-res--ok">' +
            '<p class="asq-res__tit">En ' + c + ' te la dejamos armada y funcionando, sin costo.</p>' +
            '<p>Si pagas antes de las 17:00 sale el día hábil siguiente. Los técnicos la arman en unos 20 minutos; solo necesitan la pieza despejada.</p>' +
            '<p>También puedes pagar al recibirla, con tarjeta de crédito o débito.</p></div>';
          return;
        }
        var v = RM_STARKEN[c];
        res.innerHTML = '<div class="asq-res">' +
          '<p class="asq-res__tit">' + c + ' queda fuera de nuestro reparto propio.</p>' +
          (v && conRef ? '<p>Te llega por Starken: hoy, para esta cama, <span class="asq-res__monto">' + plata(v) + '</span>. El valor exacto lo ves al pagar.</p>'
            : '<p>Te llega por Starken y el valor exacto lo ves al pagar, al elegir tu comuna.</p>') +
          '<p>Por Starken la cama viaja desarmada: se apernan ruedas y barandas con llaves de 13 y 14 mm.' + videoArmado + '</p>' +
          '<p>¿Prefieres que te ayudemos con otra opción? <a href="' + WSP + '" target="_blank" rel="noopener">Escríbenos por WhatsApp</a>.</p></div>';
        return;
      }
      var reg = REGIONES[parseInt(r.slice(1), 10)];
      res.innerHTML = '<div class="asq-res">' +
        '<p class="asq-res__tit">A ' + reg[0] + ' despachamos por Starken.</p>' +
        (conRef ? '<p>Referencia de hoy para esta cama a ' + reg[1] + ': <span class="asq-res__monto">' + plata(reg[2]) + '</span>. El valor exacto de tu comuna lo ves al pagar.</p>'
          : '<p>El valor depende de tu ciudad y lo ves exacto al pagar, al elegir tu comuna.</p>') +
        '<p>La cama viaja desarmada en su caja: la estructura es una sola pieza y se apernan ruedas y barandas con llaves de 13 y 14 mm.' + videoArmado + '</p>' +
        rural + '</div>';
    }
    selR.addEventListener('change', function () { if (selR.value !== 'RM') selC.value = ''; pintar(); });
    selC.addEventListener('change', pintar);
  }

  /* ---------- Selector de cama del listicle ---------- */
  function iniciarSelector(sel) {
    if (sel.getAttribute('data-listo')) return;
    sel.setAttribute('data-listo', '1');
    var res = sel.querySelector('[data-asq-sel-res]');
    var camas = {};
    sel.querySelectorAll('template[data-cama]').forEach(function (t) { camas[t.getAttribute('data-cama')] = t; });

    function val(n) { var i = sel.querySelector('input[name="' + n + '"]:checked'); return i ? i.value : ''; }
    function pintar() {
      var mov = val('asq-mov'), acost = val('asq-acost'), cuida = val('asq-cuida');
      if (!mov || !acost || !cuida) { res.innerHTML = ''; return; }
      var electrica = mov === 'poco' || cuida === 'una';
      var antiescaras = acost === 'todo' || mov === 'poco';
      var clave = (electrica ? 'e' : 'm') + (antiescaras ? 'a' : 's');
      var t = camas[clave];
      if (!t) return;
      var razones = [];
      razones.push(electrica
        ? 'Eléctrica: con el control remoto se sube el respaldo, las piernas y la altura sin hacer fuerza.'
        : 'Manual: se mueve con manivelas y cuesta menos. Sirve bien si hay quien ayude a cambiarlo de posición.');
      razones.push(antiescaras
        ? 'Con colchón antiescaras: si pasa muchas horas en la misma posición, la presión alternante ayuda a prevenir heridas.'
        : 'Con colchón seccionado: es la base firme de la cama. Si más adelante pasa más tiempo acostado, el antiescaras se compra aparte.');
      res.innerHTML = '';
      var card = t.content.cloneNode(true);
      var ul = card.querySelector('[data-razones]');
      razones.forEach(function (r) { var li = document.createElement('li'); li.textContent = r; ul.appendChild(li); });
      res.appendChild(card);
      if (res.scrollIntoView && window.innerWidth < 750) res.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    sel.addEventListener('change', pintar);
  }

  function iniciar() {
    document.querySelectorAll('[data-asq-desp]').forEach(iniciarDespacho);
    document.querySelectorAll('[data-asq-sel]').forEach(iniciarSelector);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();
